import {Alert, alpha, Link, Theme, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, {Dispatch, FC, SetStateAction} from "react";
import {Trans, useTranslation} from "react-i18next";
import {RoutePaths, StorageConstants} from "../../../../util/constants";
import {Link as RouterLink} from "react-router-dom";

interface IProps {
    setCookiesAllowed: Dispatch<SetStateAction<string | null>>
}

const CookiesBanner: FC<IProps> = ({setCookiesAllowed}) => {
    const theme = useTheme()
    const {t} = useTranslation()
    const matchesMd = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"))

    const handleAllowCookiesClick = () => {
        localStorage.setItem(StorageConstants.COOKIES_ALLOWED, "yes")
        setCookiesAllowed("yes")
    }

    return <Alert icon={false} action={<Button variant='contained' size={matchesMd ? 'large' : 'medium'}
                                            color='secondary'
                                            sx={{whiteSpace: 'nowrap', ml: matchesMd ? '1.25em' : '0.5em'}}
                                            onClick={handleAllowCookiesClick}>{t('accept')}</Button>}
               sx={{
        position: 'fixed',
                   bottom: '1.25em',
                   left: '50%',
                   flexDirection: {xs: 'column', sm: 'row'},
                   transform: 'translate(-50%)',
                   width: {xs: '90%', md: '70%'},
                   zIndex: theme.zIndex.drawer - 1,
                   backgroundColor: `${alpha(theme.palette.primary.main, .8)}`,
                   boxShadow: 5,
        backdropFilter: 'blur(5px)',
                   color: theme.palette.secondary.main,
                   alignItems: 'center',
                   '& .MuiAlert-action': {
                       p: 0,
                       mr: {xs: 'auto', sm: 0}
                   },
                   '& .MuiAlert-message': {
                       width: '100%',
                       textAlign: {xs: 'center', sm: 'left'}
                   },
    }}>
            <Typography color="secondary" variant={matchesMd ? 'subtitle1' : 'subtitle2'} fontWeight={600}>
            <Trans i18nKey="cookie_policy"
                   components={[<Link color="secondary" sx={{cursor: 'pointer'}} component={RouterLink}
                                      to={RoutePaths.PRIVACY}/>]}/>
        </Typography>

    </Alert>
}

export default CookiesBanner